import { z } from 'zod';
import { ORIGENES_DE_DATO, PATRON_FECHA_PARCIAL } from '../catalogos/nucleo.js';
import { esquemaId } from './comunes.js';
import { esquemaCodigoClinico } from './problema.js';
/**
 * Medicacion declarada (F2.1, plan maestro §5.4).
 *
 * El plan pide distinguir prescrito, reportado, suspendido y desconocido. Son
 * dos ejes, y se modelan asi para no perder informacion:
 * - `procedencia`: si lo prescribio un profesional o lo refiere la paciente;
 * - `estado`: si lo toma, lo suspendio o no se sabe.
 * Un medicamento reportado y suspendido es tan posible como uno prescrito y
 * activo. Esta lista es la conciliada; la receta firmada sigue siendo su propio
 * documento.
 */
export const PROCEDENCIAS_DE_MEDICACION = ['prescrito', 'reportado'];
export const ESTADOS_DE_MEDICACION = ['activo', 'suspendido', 'desconocido'];
export const esquemaRegistrarMedicacion = z
    .object({
    pacienteId: esquemaId,
    encuentroId: esquemaId.optional(),
    medicamento: z.string().trim().min(2, 'Escriba el medicamento').max(200),
    codigo: esquemaCodigoClinico.optional(),
    dosis: z.string().trim().max(120).default(''),
    via: z.string().trim().max(60).default(''),
    frecuencia: z.string().trim().max(120).default(''),
    indicacion: z.string().trim().max(300).default(''),
    procedencia: z.enum(PROCEDENCIAS_DE_MEDICACION),
    estado: z.enum(ESTADOS_DE_MEDICACION).default('activo'),
    inicio: z.string().trim().regex(PATRON_FECHA_PARCIAL).optional(),
    suspension: z.string().trim().regex(PATRON_FECHA_PARCIAL).optional(),
    motivoSuspension: z.string().trim().max(300).default(''),
    /** Si viene de una receta firmada del sistema. */
    recetaId: esquemaId.optional(),
    origen: z.enum(ORIGENES_DE_DATO).default('profesional'),
    nota: z.string().trim().max(500).default(''),
})
    .strict()
    .refine((m) => m.estado === 'suspendido' || (m.suspension === undefined && m.motivoSuspension === ''), {
    message: 'Solo un medicamento suspendido lleva fecha o motivo de suspensión',
    path: ['estado'],
})
    .refine((m) => m.recetaId === undefined || m.procedencia === 'prescrito', {
    message: 'Lo que viene de una receta es prescrito',
    path: ['procedencia'],
});
export const esquemaActualizarMedicacion = z
    .object({
    versionEsperada: z.number().int().min(0),
    estado: z.enum(ESTADOS_DE_MEDICACION).optional(),
    dosis: z.string().trim().max(120).optional(),
    frecuencia: z.string().trim().max(120).optional(),
    suspension: z.string().trim().regex(PATRON_FECHA_PARCIAL).optional(),
    motivoSuspension: z.string().trim().max(300).optional(),
    nota: z.string().trim().max(500).optional(),
})
    .strict();
//# sourceMappingURL=medicacion.js.map